import { Component, inject, input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/services/auth.service';
import { SignupModalComponent } from '../signup-modal/signup-modal.component';
import { DiscoverCourse } from './discover-course-model';
import { take } from 'rxjs/operators';
import { CheckoutModalService } from 'src/app/course/services/checkout-modal.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-discover-courses',
  templateUrl: './discover-courses.component.html',
  styleUrls: ['./discover-courses.component.scss']
})
export class DiscoverCoursesComponent {
  private modalService = inject(BsModalService);
  private authService = inject(AuthService);
  private checkoutModalService = inject(CheckoutModalService);
  private router = inject(Router);

  courses = input<DiscoverCourse[]>([]);
  showScrollbar = input(false);
  fitContent = input(false);
  user = input<any>();

  signupModal: BsModalRef;
  loginModal: BsModalRef;

  goToUrl(course: any) {
    if (course.requireRegistrationForPreview && !this.user()) {
      this.openSignupForm(event, course);
    } else {
      window.open(course.previewLink, '_blank');
    }
  }

  openSignupForm($event, course) {
    $event.stopPropagation();
    $event.preventDefault();

    const initialState = { onComplete: this.onLoginComplete, course: course };

    this.signupModal = this.modalService.show(SignupModalComponent, {
      initialState,
      class: 'modal-sm rounded-modal'
    });
    this.signupModal.content.closeBtnName = 'Close';

    this.modalService.onHide.pipe(take(1)).subscribe((value) => {
      if (this.signupModal.content.user) {
        this.onLoginComplete();
      }
    });
  }

  onLoginComplete() {
    this.authService.renew().then((value) => {});
  }

  onBuyClick(event, course): void {
    event.preventDefault();
    event.stopPropagation();

    this.checkoutModalService.buyCourse(course, true);
  }
}
